/** 전화번호 하이픈 자동 추가 */
export function formatContactNumber(value: string): string {
  value = value.replace(/[^0-9]/g, '');
  if (value.length > 11) value = value.slice(0, 11);

  let formatted = value;

  if (value.startsWith('02')) {
    if (value.length <= 2) formatted = value;
    else if (value.length <= 5)
      formatted = `${value.substring(0, 2)}-${value.substring(2)}`;
    else if (value.length <= 9)
      formatted = `${value.substring(0, 2)}-${value.substring(
        2,
        5
      )}-${value.substring(5)}`;
    else
      formatted = `${value.substring(0, 2)}-${value.substring(
        2,
        6
      )}-${value.substring(6)}`;
  } else {
    if (value.length <= 3) formatted = value;
    else if (value.length <= 7)
      formatted = `${value.substring(0, 3)}-${value.substring(3)}`;
    else if (value.length <= 10)
      formatted = `${value.substring(0, 3)}-${value.substring(
        3,
        6
      )}-${value.substring(6)}`;
    else
      formatted = `${value.substring(0, 3)}-${value.substring(
        3,
        7
      )}-${value.substring(7)}`;
  }

  return formatted;
}

/** 사업자등록번호 하이픈 자동 추가 */
export function formatBusinessNumber(value: string): string {
  value = value.replace(/[^0-9]/g, '');

  if (value.length > 3 && value.length <= 5)
    value = value.replace(/(\d{3})(\d{1,2})/, '$1-$2');
  else if (value.length > 5)
    value = value.replace(/(\d{3})(\d{2})(\d{1,5})/, '$1-$2-$3');

  return value;
}

/**
 * 숫자를 천단위 콤마로 포맷
 * @param value 숫자 또는 문자열
 * @param suffix 접미사 (예: '원', '조각')
 * @param defaultValue 값이 없을 때 표시할 기본값
 * @returns 포맷된 문자열 (예: 1,234,567원)
 */
export function formatCurrency(
  value: number | string | null | undefined,
  suffix = '',
  defaultValue = '-'
): string {
  if (value === null || value === undefined || value === '') {
    return defaultValue;
  }
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return defaultValue;
  return num.toLocaleString('ko-KR') + suffix;
}

/** 계좌번호 하이픈 자동 추가 (4자리씩 구분) */
export function formatAccountNumber(value: string): string {
  value = value.replace(/[^0-9*]/g, '');
  return value.replace(/(.{4})(?=.)/g, '$1-');
}
